/**
 * 全局过滤器
 */

/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
let privatePhone = function(val, retain = 4) {
    if (!Number(val) || String(val).length !== 11 || retain == 0) return val;
    let phone = String(val)
    let digit = 11 - 3 - retain
    let reg = new RegExp(`^(\\d{3})\\d{${digit}}(\\d{${retain}})$`)
    return phone.replace(reg, `$1${'*'.repeat(digit)}$2`)
}

export{
    privatePhone,
}